import React, { useEffect, useSelector } from "react";
import { Slide } from 'react-slideshow-image';
import "./slider.css";

export default function Slider(props) {
  var { data } = props;
  const properties = {
    duration: 3000,
    
    transitionDuration: 500,
    autoplay:true,
    infinite: true,
    indicators: true,
    arrows: true,
    pauseOnHover: true,
    onChange: (oldIndex, newIndex) => {
      console.log(`slide transition from ${oldIndex} to ${newIndex}`);
    }
  }

  useEffect(() => {
    var elems = document.querySelectorAll(".carousel");
  });

  return (
    <div className="carousel carousel-slider">
         <Slide {...properties}>
           {
             data.map((val,index)=>{
               return (
                <div className="each-slide">
                <div className="slider_image" style={{ 'backgroundImage': `url(${val.full_path})`}}>
                
                </div>
              </div>
               )
             })
           }
           
          </Slide>
    </div>
  );
}
